import { observer } from "mobx-react";
import React from "react";
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';


interface ISaveAndCancelButtons {
    onSave: any;
    onCancel: any;
}

@observer
export default class SaveAndCancelButtons extends React.Component<ISaveAndCancelButtons> {
    public render() {
        return (
            <div className="row customMarginTop29 float-right pr-3">
                <Neo.Button onClick={() => this.props.onSave()}
                    variant="primary" className="ml-3 col-md-2" isSubmit
                >{TextConstants.Buttons.Save}</Neo.Button>
                <Neo.Button className="ml-3 col-md-2"
                    onClick={() => this.props.onCancel()}
                    variant="secondary"
                >{TextConstants.Buttons.Cancel}</Neo.Button>
            </div>
        )
    }
}